import React from 'react';
import AgentCard from '../shared/AgentCard';

/**
 * @param {{
 *  history?: import('history').History,
 *  location?: import('history').Location,
 *  match?: { params?: { propertyId?: string } }
 * }} props
 * @returns {JSX.Element}
 */
export default function PropertyTeam(props) {
	void props;

	return (
		<section className="app-block-list">
			<AgentCard />
		</section>
	);
}
